<script setup>
import { useDisplay } from 'vuetify/lib/framework.mjs'

const props = defineProps({
  renderWithContainer: { type: Boolean, default: true },
  containerClass: { type: String, default: '' },
})

const { mobile } = useDisplay();
</script>

<template>
  <div style="width: 100%; max-width: 1920px; margin: 0 auto;">
    <v-container
      v-if="renderWithContainer"
      :style="mobile ? 'padding: 12px 16px;' : ''"
      :class="props.containerClass"
      fluid
    >
      <slot />
    </v-container>
    <slot v-else />
  </div>
</template>